<template>
  <div class="all-ideas">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="$route.name"></ContentHeader>
        <div class="alert alert-info">
          <button type="button" class="btn btn-primary float-right showHideBtn" v-b-toggle.filterControls v-on:click="showHideFilters()" title="Show/Hide Filters" v-b-tooltip.hover>
            <span v-html="showHideFilterText"></span>
          </button>
          <div class="mr-2 float-right">
            Download current view as:
            <button type="button" class="btn btn-link p-0" v-on:click="exportToCSV()">
              <i class="fas fa-file-excel fa-2x" v-b-tooltip.hover title="Download as a CSV file"></i>
            </button>
            <button type="button" class="btn btn-link p-0" v-on:click="exportToPDF()">
              <i class="fas fa-file-pdf fa-fw fa-2x" title="Download as a PDF document" v-b-tooltip.hover></i>
            </button>
          </div>
          <h4 class="alert-heading">Filtered Search</h4>
          <b-collapse visible id="filterControls" accordion="link-accordion" role="tabpanel">
            <hr>
            <div class="row">
              <div class="col-sm-6 mb-2">
                <label>Idea Challenge</label>
                <select v-model="ideaCategorySelect" v-on:change="changeCommunityCategory()" class="form-control">
                  <option>-- All --</option>
                  <option v-for="category in ideaCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
                </select>
              </div>
              <div class="col-sm-6 mb-2">
                <label>Community</label>
                <select v-model="communityCategorySelect" v-on:change="loadIdeas()" class="form-control">
                  <option>-- All --</option>
                  <option v-for="category in communityCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 mb-2">
                <label class="d-none d-xl-block">&nbsp;</label>
                <div class="form-check form-control pl-5">
                  <input class="form-check-input" type="checkbox" v-model="graduatedIdeasCheck" id="graduatedIdeasCheck" v-on:change="filterByGraduatedIdeas()">
                  <label class="form-check-label" for="graduatedIdeasCheck"><i class="fas fa-star fa-fw" style="color: darkgoldenrod"></i> Graduated ideas</label>
                </div>
              </div>
              <div class="col-sm-6 mb-2 authorControls">
                <label for="ideaAuthorFilter">Idea author:</label>
                <div class="input-group">
                  <input type="text" id="ideaAuthorFilter" v-model="ideaAuthorFilter" v-on:keyup.enter="filterByAuthor()" class="form-control" placeholder="Filter by author...">
                  <div class="input-group-append">
                    <button v-on:click="filterByAuthor()" type="submit" id="searchsubmit" class="btn btn-primary">{{ideaAuthorFilterButton}}</button>
                  </div>
                </div>
                <ul class="list-group autoCompleteBox">
                  <li v-for="user in filteredThinktankUsers" v-bind:key="user.id" class="list-group-item" v-on:click="selectAuthor(user.name)">{{user.name}}</li>
                </ul>
              </div>
            </div>
          </b-collapse>
        </div>
        <Ideas v-if="ideas.length > 0" :ideas="ideas"></Ideas>
        <span v-if="ideas.length === 0">
          No ideas have been submitted, <router-link to="/idea-challenges">view the Idea Challenges here</router-link> and submit an idea
        </span>
        <div class="row">
          <div class="col-sm-6 mt-3">
            <b-pagination size="md" :total-rows="totalPosts" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>
          </div>
          <div class="col-sm-6 mt-3">
            <div class="items-per-page">
              <label for="itemsPerPage">Ideas per page: </label>
              <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadIdeas()" class="form-control">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ExportToCSV from '@/helpers/ExportToCSV.js'
import ContentHeader from '@/components/ContentHeader'
import Ideas from '@/components/Ideas'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    Ideas
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUserCommunityIDstring',
      'getUserCommunityIDs'
    ]),
    filteredThinktankUsers: function () {
      return this.thinktankUsers.filter(x => x.name.indexOf(this.ideaAuthorFilter) > -1)
    },
    isMakeMark: function () {
      return this.$route.name === 'Report: Make your mark'
    }
  },
  data () {
    return {
      ideas: [],
      contentReady: false,
      contentLoadError: '',
      ideaCategories: [],
      ideaCategorySelect: '-- All --',
      communityCategorySelect: '-- All --',
      communityCategories: [],
      excludedCommunityCategories: [],
      graduatedIdeasCheck: false,
      thinktankUsers: [],
      currentPage: 1,
      totalPosts: 0,
      itemsPerPage: 10,
      showHideFilterText: '<i class="fas fa-angle-up"></i>',
      ideaAuthorFilter: '',
      ideaAuthorFilterButton: '+'
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    this.loadFilters()
  },
  methods: {
    exportToPDF: function () {
      window.print()
    },
    exportToCSV: function () {
      // Map fields of nominations array that will be converted to CSV
      const items = this.ideas.map(function (x) {
        return {
          date: x.date,
          title: x.title.rendered,
          idea: x.content.rendered.replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, ''),
          author: x._embedded.author[0].name
        }
      })
      // Convert to JSON and then create CSV file for download
      ExportToCSV.createCSV(items, 'Ideas')
    },
    changeCommunityCategory: function () {
      this.graduatedIdeasCheck = false
      this.loadIdeas()
    },
    filterByGraduatedIdeas: function () {
      if (this.graduatedIdeasCheck) {
        this.ideaCategorySelect = 29
      } else {
        this.ideaCategorySelect = '-- All --'
      }
      this.loadIdeas()
    },
    selectAuthor: function (user) {
      this.ideaAuthorFilter = user
      this.loadIdeas()
      this.ideaAuthorFilterButton = 'x'
    },
    filterByAuthor: function () {
      if (this.ideaAuthorFilterButton === '+') {
        this.ideaAuthorFilterButton = 'x'
      } else {
        this.ideaAuthorFilterButton = '+'
        this.ideaAuthorFilter = ''
      }
      this.loadIdeas()
    },
    getAuthorSearchQuery: function () {
      let authorFilter = this.thinktankUsers.filter(x => x.name === this.ideaAuthorFilter).map(x => x.id).join()
      if (authorFilter !== '') {
        return '&author=' + authorFilter
      }
    },
    generateSearchQuery: function () {
      let ideaCatFilter = ''
      let communityFilter = ''
      let authorFilter = ''
      if (this.ideaCategorySelect !== '-- All --') {
        ideaCatFilter = '&idea_chalenge_category=' + this.ideaCategorySelect
      }
      if (this.isMakeMark && this.ideaCategorySelect === '-- All --') {
        ideaCatFilter = '&idea_chalenge_category=10'
      }
      if (!this.isMakeMark) {
        ideaCatFilter += '&idea_chalenge_category_exclude=10'
      } else {
        console.log(this.excludedCommunityCategories)
        ideaCatFilter += '&idea_chalenge_category_exclude=' + this.excludedCommunityCategories
      }
      if (this.communityCategorySelect !== '-- All --') {
        communityFilter = '&community_categories=' + this.communityCategorySelect
      }
      if (this.ideaAuthorFilter !== '') {
        authorFilter = this.getAuthorSearchQuery()
      }
      return '?_embed' + ideaCatFilter + communityFilter + authorFilter
    },
    loadFilters: function () {
      WordpressRestAPI.getViewContent('idea_chalenge_category?per_page=100')
        .then(response => {
          if (this.isMakeMark) {
            this.ideaCategories = response.data.filter(x => x.id === 10 || x.parent === 10 || x.id === 29)
            this.excludedCommunityCategories = response.data.filter(x => x.id !== 10 && x.parent !== 10 && x.id !== 29).map(x => x.id).join()
          } else {
            this.ideaCategories = response.data.filter(x => x.id !== 10 && x.parent !== 10)
          }
          this.loadIdeas()
        })
        .catch(e => {
          console.error(e)
        })
      WordpressRestAPI.getViewContent('community_categories?per_page=100')
        .then(response => {
          this.communityCategories = response.data
        })
        .catch(e => {
          console.error(e)
        })
      WordpressRestAPI.getViewContent('users')
        .then(response => {
          this.thinktankUsers = response.data
        })
        .catch(e => {
          console.error(e)
        })
    },
    loadIdeas: function () {
      this.contentReady = false
      WordpressRestAPI.getViewContent('idea' + this.generateSearchQuery() + '&page=' + this.currentPage + '&per_page=' + this.itemsPerPage)
        .then(response => {
          this.totalPosts = parseInt(response.headers['x-wp-total'])
          this.ideas = response.data
          if (!this.$store.getters.isAdmin && this.getUserCommunityIDstring !== undefined) {
            this.ideas = this.ideas.filter(x => x.community_categories.some(v => this.getUserCommunityIDs.includes(v)))
          }
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem loading ideas. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    },
    showHideFilters: function () {
      if (this.showHideFilterText === '<i class="fas fa-angle-up"></i>') {
        this.showHideFilterText = '<i class="fas fa-angle-down"></i>'
      } else {
        this.showHideFilterText = '<i class="fas fa-angle-up"></i>'
      }
    }
  },
  watch: {
    getUserCommunityIDstring (newDetails, oldDetails) {
      this.loadFilters()
    },
    'currentPage' (newDetails, oldDetails) {
      this.loadIdeas()
    },
    '$route' (to, from) {
      document.title = this.$route.name + ' - ThinkTank'
      this.loadFilters()
    }
  }
}
</script>

<style lang="less">
  .showHideBtn {
    padding: 4px 8px;
  }
  .authorControls {
    &:hover {
      .autoCompleteBox {
        height: 203px;
        overflow-y: scroll;
        margin-bottom: -203px;
        border-bottom: 2px solid lightgrey;
      }
    }
  }
  .autoCompleteBox {
    overflow: hidden;
    height: 0;
    margin-bottom: 0;
    border: none;
    position: relative;
    z-index: 1000;
    transition: all 0.35s;
    background: white;
    li {
      cursor: pointer;
      transition: color 0.25s;
      &:hover {
        color: #007bff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/routes/ReportIdeaChallenges.vue